import { useEffect, useState } from 'react'

import { getCdcWebSignupLink } from './index'

export function isOgApp(): boolean {
  return !!window.isOgApp || !!window.ReactNativeWebView
}

export function useIsOgApp() {
  const [isOg, setIsOg] = useState(false)

  useEffect(() => {
    setIsOg(!!window.isOgApp || !!window.ReactNativeWebView)
  }, [])

  return isOg
}

/**
 * Sends a message to the OG App (ReactNativeWebView).
 * @param url - Optional URL to pass in the payload
 * @param type - Message type
 */
export function openUrlInOgApp(type: string, url?: string) {
  if (isOgApp()) {
    const payload = {
      type,
      ...(url && { url }),
    }

    window.ReactNativeWebView!.postMessage(JSON.stringify(payload))
  } else if (url) {
    window.location.href = url
  }
}

export function gotoCdcWebSignupPageOg() {
  if (isOgApp()) {
    openUrlInOgApp('OPEN_EXTERNAL_BROWSER', getCdcWebSignupLink())
  } else {
    /**
     * Load by iframe in OG web, post message to parent
     */
    window.parent?.postMessage(
      {
        type: 'openCdcWeb',
      },
      '*',
    )
  }
}

export function sendMsgPageOgHome() {
  openUrlInOgApp('GO_BACK')
}
